import { enumAvailableLanguages } from "../../src/models/SettingsEnums";

/** Languages present in C1 definition/product data; UI text uses the main itx dictionary. */
export type C1_Language = "de" | "en";

/** Maps the main application's locale enum to the translation keys used by C1 catalogs. */
export function toC1Language(language: enumAvailableLanguages): C1_Language {
  return language === enumAvailableLanguages.german ? "de" : "en";
}
